import React from 'react';

import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Textarea } from '@/components/ui/textarea';
import { useConversations } from '../../hooks';

const ReplyForm = () => {
  const { activeConversation, isLoadingActive: isLoading } = useConversations();

  const placeholder = isLoading
    ? 'Reply...'
    : `Reply to ${activeConversation.lastMessage.sender.fullName}...`;

  return (
    <div className="flex flex-col gap-4 p-4 border-t">
      <div>
        <Label className="sr-only" htmlFor="reply">
          Reply
        </Label>

        <Textarea
          className="bg-muted/50"
          disabled={isLoading}
          id="reply"
          placeholder={placeholder}
        />
      </div>

      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Switch disabled={isLoading} id="mute" />

          <Label className="text-muted-foreground" htmlFor="mute">
            Mute this thread
          </Label>
        </div>

        <Button disabled={isLoading} variant="default">
          Send
        </Button>
      </div>
    </div>
  );
};

export default ReplyForm;
